import { createContext } from "react";

//Context.displayName is mandatory to availe data in consumer with that name

export const WebConfigDataContext = createContext(null);
WebConfigDataContext.displayName = "WebConfigData";

export const ConstraintsContext = createContext(null);
ConstraintsContext.displayName = "ConstraintsData";

export const TransContext = createContext(null);
TransContext.displayName = "TransData";

export const FixturesContext = createContext(null);
FixturesContext.displayName = "FixturesData";

export const CompositionContext = createContext(null);
CompositionContext.displayName = "CompositionData";

export const PlayerListContext = createContext(null);
PlayerListContext.displayName = "PlayerListData";

export const TeamDataContext = createContext(null);
TeamDataContext.displayName = "TeamData";

export const PlayerDetailTogglerContext = createContext(null);
PlayerDetailTogglerContext.displayName = "PlayerDetailTogglerData";

export const PlayerRecommendationContext = createContext(null);
PlayerRecommendationContext.displayName = "PlayerRecommendationData";

export const LoginContext = createContext(null);
LoginContext.displayName = "loginData";

export const ShowToastContext = createContext(null);
ShowToastContext.displayName = "ShowToast";

export const GamedaysContext = createContext(null);
GamedaysContext.displayName = "Gamedays";

export const ShowPopUpContext = createContext(null);
ShowPopUpContext.displayName = "ShowPopUp";

export const PlayerCardContext = createContext(null);
PlayerCardContext.displayName = "PlayerCardData";

export const LiveScoringContext = createContext(null);
LiveScoringContext.displayName = "LiveScoringData";

export const BoosterCardContext = createContext(null);
BoosterCardContext.displayName = "BoosterCardData";

export const LeaguesContext = createContext(null);
LeaguesContext.displayName = "LeaguesData";

export const FetchGamerCardContext = createContext(null);
FetchGamerCardContext.displayName = "FetchGamerCardData";

export const GeolocationUrlContext = createContext(null);
GeolocationUrlContext.displayName = "GeolocationUrlData";

export const PlayersStatisticsContext = createContext(null);
PlayersStatisticsContext.displayName = "PlayersStatisticsData";

export const GamerCardContext = createContext(null);
GamerCardContext.displayName = "GamerCard";

export const MixApiContext = createContext(null);
MixApiContext.displayName = "MixApiData";
